import { getBezierPath, getSmoothStepPath, getStraightPath, ConnectionLineType } from "reactflow";

export const getEdgePath = (lineType: ConnectionLineType, props: any) => {
    switch (lineType) {
        case ConnectionLineType.Straight:
            return getStraightPath(props);
        case ConnectionLineType.Step:
            return getSmoothStepPath(props);
        default:
            return getBezierPath(props);
    }
};
